import { SettingConst } from '@faire/web-api--source/types';

/**
 * Config setting to enable the Elevate Top Shop experiment for logged in retailers in NAM.
 * This enhances retailer experinece, notably by introducing a "Top Shop" toggle filter that retailers
 * can apply wherever they search products for brands.
 * This is also applicable to logged out users.
 */
export const ELEVATE_TOP_SHOP_V2 = 'ELEVATE_TOP_SHOP_V2' as SettingConst<
  'ELEVATE_TOP_SHOP_V2',
  boolean,
  'RETAILER' | 'VISITOR_WEB'
>;
